import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { PageStructure } from "../../pages";
import { PoolActionButton, PoolActionsTable } from "../../components";

const PoolActions = () => {
  return (
    <PageStructure>
      <Typography variant="h4" component="h1" gutterBottom>
        Pool Actions
      </Typography>
      <Divider sx={{ mb: 2 }} />
      
      <Box sx={{ mb: 3 }}>
        <PoolActionButton />
      </Box>
      
      <PoolActionsTable />
    </PageStructure>
  );
};

export default PoolActions;
